(function () {
    'use strict';

    angular.module('notes')
        .service('notesConfigService', notesConfigService);

    notesConfigService.$inject = ['serviceBase'];
    function notesConfigService(serviceBase) {
        return {
            SaveNote: serviceBase + '/road-monitoring/note/',
            GetNotes: serviceBase + '/road-monitoring/note/?p=',
            ModifyNote: serviceBase + '/road-monitoring/note/'
        };
    }
})();
